import { useGTM } from '@jusbrasil-web/shared-gtm'

export const LEGAL_RESEARCH_SUCCESS_PROXIES = 'Legal research success proxies'

export function useGADispatcher() {
  const gtm = useGTM()

  return {
    sendGAEvent: (
      eventCategory: string,
      eventAction: string,
      eventLabel?: string,
      eventValue?: string | number
    ) =>
      gtm.push({
        event: 'gaEvent',
        event_category: eventCategory,
        event_action: eventAction,
        event_label: eventLabel,
        event_value: eventValue,
      }),
  }
}
